// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

// types
type Types = any;

const svgIcon: Types = {
  defaultProps: {
    fontSize: 'inherit'
  },

  styleOverrides: {
    fontSizeInherit: {
      fontSize: 'inherit !important'
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`
    }
  }
};

export default svgIcon;
